import {useState, useEffect} from 'react';
import {getOrganization} from '@/api/participant';

export const useOrganization = (slug) => {
    const [organization, setOrganization] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        if (!slug) return;

        let isMounted = true;

        const fetchData = async () => {
            try {
                setLoading(true);
                const data = await getOrganization(slug);
                if (isMounted) {
                    setOrganization(data);
                }
            } catch (err) {
                console.error("Erreur chargement organisation:", err);
                if (isMounted) setError(err);
            } finally {
                if (isMounted) setLoading(false);
            }
        };

        fetchData();

        return () => {
            isMounted = false;
        };
    }, [slug]);

    return {organization, loading, error};
};